var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 99,
    viewBox: "0 0 60 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.5534 49.4439C20.5534 49.4439 19.1217 63.1097 21.1928 66.4247C23.264 69.7396 24.3016 92.3891 23.3726 95.2378C23.3726 95.2378 30.0405 96.5637 32.6787 94.6795C35.3169 92.7952 39.3748 94.6097 46.0588 92.7761C52.7428 90.9426 47.9208 50.2465 47.9208 50.2465L48.1259 35.4418L37.1025 27.6953L20.5534 49.4439Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4412 56.0158C29.3996 56.1135 29.3325 56.2032 29.2441 56.2791C27.8205 57.3418 21.7437 58.5218 16.5236 59.372C12.2003 60.0794 8.48029 60.5584 8.48029 60.5584C8.48029 60.5584 5.61687 41.7885 5.61687 39.8154C5.61687 37.8423 1 5.89823 1 5.89823L12.0676 5.52074L26.7507 5.01953C26.7507 5.01953 26.8392 5.87285 26.988 7.36379C27.9572 16.8613 31.2871 52.2694 29.4412 56.0158Z",
    fill: "#D5CDDD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1121_14280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 5,
    width: 29,
    height: 56
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4412 56.0197C29.3996 56.1174 29.3325 56.2071 29.2441 56.283C27.8205 57.3457 21.7437 58.5257 16.5236 59.3759C12.2003 60.0833 8.48029 60.5623 8.48029 60.5623C8.48029 60.5623 5.61687 41.7924 5.61687 39.8193C5.61687 37.8462 1 5.90214 1 5.90214L12.0676 5.52465L26.7507 5.02344C26.7507 5.02344 26.8392 5.87676 26.988 7.36769C27.9572 16.8653 31.2871 52.2733 29.4412 56.0197Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1121_14280)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.4406 56.0172L16.5231 58.1013L11.6448 58.8912C10.3216 57.8666 9.31221 57.8475 9.31221 57.8475L8.91005 54.9767L8.27864 50.2787L2.7207 8.94491C3.9272 8.28826 4.52241 6.85126 4.52241 6.85126L11.9625 6.63872L24.8519 6.26758L26.9794 7.35247C27.9566 16.8627 31.2866 52.2708 29.4406 56.0172Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4406 56.0172L16.5231 58.1013L11.6448 58.8912C10.3216 57.8666 9.31221 57.8475 9.31221 57.8475L8.91005 54.9767L8.27864 50.2787L2.7207 8.94491C3.9272 8.28826 4.52241 6.85126 4.52241 6.85126L11.9625 6.63872L24.8519 6.26758L26.9794 7.35247C27.9566 16.8627 31.2866 52.2708 29.4406 56.0172Z",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 43.8521L14.3073 43.8457L14.3113 44.9084L13.1129 45.2446L10.35 45.4826L9.99609 43.8521Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2617 46.0388L13.4308 45.9531L14.2432 46.2577L14.2029 47.6693L10.503 47.701L10.2617 46.0388Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7682 48.296L14.3877 48.0898L14.3474 49.1589L12.598 49.6474L10.748 49.5649L10.7682 48.296Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9852 50.0977L13.909 50.215L14.1744 50.8051L13.7481 51.4554L11.134 51.5886L10.6836 50.583L10.9852 50.0977Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3553 52.1621L14.7575 53.0852C14.8217 53.1833 14.8552 53.2921 14.8552 53.4024C14.8552 53.5128 14.8217 53.6216 14.7575 53.7197C14.6827 53.7871 14.5872 53.8383 14.4802 53.8683C14.3732 53.8982 14.2582 53.9061 14.1462 53.891C13.921 53.8751 13.6998 53.8148 13.4746 53.8053C12.7949 53.7831 12.1716 54.224 11.504 54.1225C11.2426 53.5515 10.583 52.7141 11.4758 52.4571C11.6407 52.4159 14.4518 52.3715 14.3553 52.1621Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3427 54.7598C14.4065 54.9793 14.4522 55.2018 14.4794 55.4259C14.5202 55.5676 14.5143 55.7152 14.4622 55.8546C14.4101 55.994 14.3136 56.1206 14.1818 56.2222C14.0103 56.2965 13.8185 56.3367 13.6228 56.3395L11.2983 56.5045C11.2644 56.1583 11.2577 55.8108 11.2782 55.464C11.4149 55.0516 11.3184 55.0865 11.8131 54.9184C12.5973 54.6551 13.5384 55.0738 14.3427 54.7598Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88965 9.88672C5.88965 9.88672 6.76637 16.5705 6.80659 17.8933",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7793 9.95898L8.18951 13.6419",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3311 8.56836L14.8619 12.8857L15.6059 12.9428L15.3646 8.6096L14.3311 8.56836Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.44 56.0197C29.3984 56.1174 29.3313 56.2071 29.2429 56.283C27.8193 57.3457 21.7425 58.5257 16.5224 59.3759V56.5209L8.92547 54.9856L7.7793 54.754L8.29407 50.2875L10.2607 33.2211L11.9779 6.65395L12.0503 5.52465L26.7495 5.02344C26.7495 5.02344 26.838 5.87676 26.9868 7.36769C27.956 16.8653 31.2859 52.2733 29.44 56.0197Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4412 56.0158C29.3996 56.1135 29.3325 56.2032 29.2441 56.2791C27.8205 57.3418 21.7437 58.5218 16.5236 59.372C12.2003 60.0794 8.48029 60.5584 8.48029 60.5584C8.48029 60.5584 5.61687 41.7885 5.61687 39.8154C5.61687 37.8423 1 5.89823 1 5.89823L12.0676 5.52074L26.7507 5.01953C26.7507 5.01953 26.8392 5.87285 26.988 7.36379C27.9572 16.8613 31.2871 52.2694 29.4412 56.0158Z",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2315 98.6099C37.324 97.9406 35.9888 88.3383 35.9647 87.2947C35.9003 84.4397 34.8748 80.6933 34.8748 80.6933C33.4431 77.8066 32.3291 71.1546 28.5085 66.8879C24.6879 62.6213 24.6919 57.6029 24.0565 53.3426C23.4211 49.0824 23.5779 49.4504 23.7388 45.6691C23.8549 42.8287 23.6949 39.9855 23.2602 37.1644C22.9425 34.6521 22.3071 30.2332 23.2602 28.1744C24.2134 26.1157 26.7068 25.6367 29.4375 27.6986C32.1682 29.7605 33.2822 38.2144 33.2822 39.2581C33.2822 40.3017 33.2822 43.5628 34.2394 44.819C34.2394 44.819 39.6485 42.6365 39.6485 42.0338C39.6485 41.431 39.4876 36.1049 40.2839 35.8194L37.1028 27.6986L43.1353 26.0078C44.2708 26.8112 45.2517 27.7409 46.047 28.7676C46.7279 29.6177 47.2978 30.5201 47.7481 31.4608C50.2938 36.7869 54.3839 40.5016 55.2284 42.0338C56.073 43.5659 55.2284 55.7345 55.2284 57.9963C55.2284 60.258 53.3785 70.6851 53.4267 72.4393C53.4629 73.7082 54.5488 78.4284 55.6306 82.0479C56.0328 83.4436 58.4739 93.5566 58.8479 94.3592L56.7995 96.4665L53.2629 98.3262L37.2315 98.6099Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.9931 35.2833C41.9529 35.9653 42.9865 41.4025 42.9865 41.4025C43.7023 42.757 39.7933 47.3757 39.7933 47.3757C38.9487 47.7501 38.5868 50.0721 38.5868 50.0721C35.9405 49.609 29.8799 44.8031 29.8799 44.8031C29.8799 44.8031 29.164 46.773 28.3597 51.6487C27.5554 56.5244 32.6548 68.1061 34.8265 76.1032C36.9982 84.1003 35.9647 87.2852 35.9647 87.2852C35.9003 84.4302 34.8748 80.6838 34.8748 80.6838C33.4431 77.7971 32.3291 71.145 28.5085 66.8784C24.6879 62.6118 24.6919 57.6029 24.0565 53.3426C23.4211 49.0824 23.5779 49.4504 23.7388 45.6691C23.8549 42.8287 23.6949 39.9855 23.2602 37.1644C22.9425 34.6521 22.3071 30.2332 23.2602 28.1744C24.2134 26.1157 26.7068 25.6367 29.4375 27.6986C32.1682 29.7605 33.2822 38.2144 33.2822 39.2581C33.2822 40.3017 33.2822 43.5628 34.2394 44.819C34.2394 44.819 39.6485 42.6365 39.6485 42.0338C39.6485 41.431 39.4876 36.1049 40.2839 35.8194L37.1028 27.6986L43.1353 26.0078C44.2708 26.8112 45.2517 27.7409 46.047 28.7676C44.0965 31.8447 42.0334 34.8582 41.9931 35.2833Z",
    fill: "#D5CDDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.1352 73.2776C52.4006 71.3743 53.1929 66.8508 53.6956 64.0275C53.0803 66.2322 52.0869 67.3488 52.0869 67.3488C52.0869 67.3488 53.8001 51.1706 53.969 50.184C54.138 49.1975 55.8673 44.7627 55.2319 42.0156C56.0764 43.5446 55.2319 55.7164 55.2319 57.9781C55.2319 60.2399 53.3819 70.6669 53.4301 72.4212C53.4663 73.69 55.1916 81.776 56.2735 85.3954C53.9489 82.7308 51.8697 75.1905 52.1352 73.2776Z",
    fill: "#D5CDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8397 94.3396C57.5689 91.4529 53.4869 74.1645 53.4386 72.4197C53.3904 70.675 55.2404 60.2353 55.2404 57.9767C55.2404 55.7181 56.0849 43.5432 55.2404 42.0142C54.3958 40.4852 50.3058 36.7674 47.7601 31.4413C46.7978 29.3586 45.2159 27.4886 43.1472 25.9883L37.1147 27.6791L40.2959 35.7999C39.4915 36.0854 39.6604 41.4115 39.6604 42.0142C39.6604 42.6169 34.2513 44.7994 34.2513 44.7994C33.2941 43.5305 33.2941 40.2822 33.2941 39.2386C33.2941 38.1949 32.1801 29.7378 29.4494 27.6791C26.7187 25.6203 24.2213 26.093 23.2722 28.1549C22.323 30.2168 22.9544 34.6325 23.2722 37.1449C23.7074 39.9691 23.8674 42.8155 23.7507 45.6591C23.5899 49.4403 23.429 49.066 24.0684 53.3326C24.7079 57.5992 24.7039 62.6177 28.5204 66.8843C32.337 71.1509 33.455 77.803 34.8867 80.6897C34.8867 80.6897 37.5893 96.097 37.2434 98.6063",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2393 44.8047C34.2393 44.8047 35.1924 48.3163 37.34 50.0737",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8193 46.4023C34.8193 46.4023 38.841 47.373 40.5221 47.4333",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6484 42.0171C39.6484 42.0171 42.5119 40.9734 44.3417 41.6015",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2842 35.8042C40.2842 35.8042 42.5122 35.6424 42.9867 34.7637",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2451 67.7812C29.2451 67.7812 33.5242 71.9717 34.795 74.1034",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1255 49.4434C53.4096 52.771 52.4525 61.8689 52.1348 63.4994",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4938 43.168C55.6144 46.1816 54.6895 47.7486 54.6895 47.7486",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6008 1L52.0877 7.13503C52.0877 7.13503 41.7239 31.9448 39.6205 35.0218L36.1056 56.6499C36.1056 56.6499 17.2681 55.9964 8.60547 53.9313C8.60547 53.9313 14.083 31.4087 14.3766 28.4046C14.6701 25.4006 22.6008 1 22.6008 1Z",
    fill: "#D5CDDD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1121_14280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 1,
    width: 45,
    height: 56
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6018 1L52.0887 7.13503C52.0887 7.13503 41.7248 31.9448 39.6215 35.0218L36.1066 56.6499C36.1066 56.6499 17.2691 55.9964 8.60645 53.9313C8.60645 53.9313 14.084 31.4087 14.3775 28.4046C14.6711 25.4006 22.6018 1 22.6018 1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1121_14280)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.2594 27.0709L22.7584 5.1542C22.7584 5.1542 25.5535 4.05979 26.6353 3.06055L47.7611 7.79981C47.7611 7.79981 47.8254 9.43349 49.0359 10.4803L38.3745 34.7127L35.7886 52.5754C35.7886 52.5754 32.3501 52.7911 32.0203 54.7959C32.0203 54.7959 20.8722 55.2718 13.396 53.7174C13.396 53.7174 12.5152 51.5508 11.168 50.1804L16.2594 27.0709Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2594 27.0709L22.7584 5.1542C22.7584 5.1542 25.5535 4.05979 26.6353 3.06055L47.7611 7.79981C47.7611 7.79981 47.8254 9.43349 49.0359 10.4803L38.3745 34.7127L35.7886 52.5754C35.7886 52.5754 32.3501 52.7911 32.0203 54.7959C32.0203 54.7959 20.8722 55.2718 13.396 53.7174C13.396 53.7174 12.5152 51.5508 11.168 50.1804L16.2594 27.0709Z",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6687 28.2068C21.6687 28.2068 23.587 22.4969 30.3434 23.5215C37.0998 24.5461 33.2833 31.5821 33.2833 31.5821C33.2833 31.5821 33.3235 37.2603 27.8419 36.4768C23.0883 35.7979 20.5547 33.7392 21.6687 28.2068Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3286 7.24219C25.3286 7.24219 23.2856 13.7674 22.7588 15.0236",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0781 7.80273L25.8877 11.381",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9946 10.3125L46.0605 11.4418L45.6141 12.4474H44.3433L41.6367 11.9462L41.9946 10.3125Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3184 12.4473L44.3427 13.1991L44.9781 13.7003L44.3427 15.0199L40.8398 14.0778L41.3184 12.4473Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8401 14.7031L44.343 15.4645L43.8484 16.4605H41.9944L40.2852 15.8959L40.8401 14.7031Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2846 16.4668L42.9871 17.3455V17.9704L42.3115 18.4748L39.7939 17.9101V16.8411L40.2846 16.4668Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.589 19.2978V20.2749C42.6099 20.3825 42.5986 20.4925 42.556 20.596C42.5134 20.6996 42.4407 20.7938 42.3437 20.8713C42.2438 20.9143 42.1317 20.9368 42.0179 20.9368C41.9041 20.9368 41.7921 20.9143 41.6922 20.8713C41.4871 20.7951 41.29 20.6809 41.097 20.6143C40.4656 20.4145 39.6894 20.6651 39.0861 20.3986C39.0861 19.7927 38.8167 18.8315 39.7658 18.8125C39.9226 18.822 42.589 19.5199 42.589 19.2978Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4746 21.7416C41.4443 21.9653 41.3932 22.1868 41.3218 22.4046C41.2333 22.6869 41.0604 23.001 40.7025 23.0771C40.5097 23.1024 40.3121 23.0893 40.1274 23.039L37.8672 22.5696C37.9765 22.2358 38.1108 21.9074 38.2694 21.5862C38.575 21.2341 38.4704 21.2404 39.0053 21.2119C39.874 21.1833 40.5818 21.8273 41.4746 21.7416Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8426 8.24219L32.4873 12.4454L33.1629 12.696L34.7957 8.55307L33.8426 8.24219Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8577 36.4688L21.0322 37.3221L20.6944 38.3499L19.4276 38.4387L16.6768 38.1183L16.8577 36.4688Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4158 38.6445L19.5084 39.1901L20.2001 39.6469L19.7095 41.0046L16.1182 40.3004L16.4158 38.6445Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.187 40.9277L19.7583 41.448L19.3722 42.4726L17.5262 42.5995L15.7607 42.1522L16.187 40.9277Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8224 42.7129L18.6134 43.4076L18.6818 44.0325L18.0625 44.5781L15.4926 44.1848L15.376 43.1221L15.8224 42.7129Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.424 45.382L18.5326 46.3559C18.5656 46.462 18.5664 46.5727 18.5349 46.679C18.5035 46.7854 18.4407 46.8845 18.3516 46.9681C18.2569 47.0176 18.1479 47.0474 18.0346 47.0546C17.9214 47.0618 17.8077 47.0462 17.7041 47.0093C17.491 46.9491 17.302 46.8476 17.0808 46.7968C16.4333 46.6382 15.6853 46.9395 15.0699 46.7143C14.9976 46.1116 14.6316 45.1726 15.5727 45.0997C15.7174 45.0933 18.4481 45.6041 18.424 45.382Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.583 47.8932C17.5773 48.1239 17.5504 48.354 17.5025 48.5816C17.4422 48.8671 17.3055 49.1938 16.9596 49.2921C16.7696 49.3303 16.5705 49.3303 16.3805 49.2921L14.0801 48.9749C14.1575 48.6341 14.2609 48.2972 14.3898 47.9662C14.6552 47.595 14.5506 47.6077 15.0815 47.5443C15.926 47.4459 16.6982 48.0391 17.583 47.8932Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2402 50.973C34.2402 50.973 35.1974 42.554 35.1974 41.707",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3301 50.594C32.3301 50.594 32.7322 46.2164 32.8046 45.4551",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8701 47.4336L23.5791 52.4171H24.8701L25.8071 47.4336H24.8701Z",
    fill: "#D5CDDD",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.6895 34.8985C36.8985 34.4385 34.4091 33.7629 32.5671 32.789C32.5671 32.789 33.9023 35.8153 38.6358 40.9733L36.0901 56.6503C36.0901 56.6503 23.7959 56.2252 14.5059 54.9722C17.3612 48.6278 22.5492 36.6052 21.9339 34.2228C21.1014 30.9523 24.0412 27.0917 24.0412 27.0917C33.3353 25.7721 42.3478 20.2303 48.5332 15.5449C45.3842 22.8886 41.085 32.7224 39.6895 34.8985Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6008 1L52.0877 7.13503C52.0877 7.13503 41.7239 31.9448 39.6205 35.0218L36.1056 56.6499C36.1056 56.6499 17.2681 55.9964 8.60547 53.9313C8.60547 53.9313 14.083 31.4087 14.3766 28.4046C14.6701 25.4006 22.6008 1 22.6008 1Z",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9487 50.3895L34.7944 74.1049C33.8694 72.5536 31.3478 69.908 30.0448 68.5852C29.5622 68.0904 29.2404 67.7826 29.2404 67.7826L28.5045 66.8881C24.6879 62.6215 24.6879 57.6031 24.0525 53.3365C23.4171 49.0699 23.5739 49.4442 23.7348 45.6629C23.8518 42.8247 23.6931 39.9837 23.2602 37.1646C22.9425 34.6522 22.3071 30.2333 23.2602 28.1746C23.7267 27.1658 24.5673 26.5377 25.621 26.4045C26.6746 26.2713 28.0339 26.6519 29.4375 27.6987C32.1682 29.7575 33.2822 38.2146 33.2822 39.2582C33.2822 40.3019 33.2822 43.5629 34.2394 44.8191C34.2394 44.8032 36.8052 48.6321 38.9487 50.3895Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.1908 65.1952C29.0595 66.0707 29.6507 67.3332 30.0448 68.5831C29.5622 68.0882 29.2404 67.7805 29.2404 67.7805L28.5045 66.8859C24.6879 62.6193 24.6879 57.6009 24.0525 53.3343C23.4171 49.0677 23.5739 49.442 23.7348 45.6608C23.8518 42.8226 23.6931 39.9815 23.2602 37.1624C22.9425 34.6501 22.3071 30.2312 23.2602 28.1724C23.7267 27.1637 24.5673 26.5356 25.621 26.4023C27.6318 26.8528 29.6426 28.4674 30.3424 31.2304C31.5489 35.8682 26.1076 32.1218 24.8488 36.0522C23.59 39.9825 25.4199 41.042 26.1719 42.0318C26.924 43.0215 25.9628 45.204 24.8488 48.1351C23.7348 51.0662 25.8059 62.7875 28.1908 65.1952Z",
    fill: "#D5CDDD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9499 50.3878C36.8023 48.6304 34.2406 44.8015 34.2406 44.8015C33.2834 43.5326 33.2834 40.2843 33.2834 39.2406C33.2834 38.197 32.1694 29.7399 29.4387 27.6811C26.708 25.6224 24.2105 26.0951 23.2614 28.157C22.3123 30.2189 22.9437 34.6346 23.2614 37.147C23.6967 39.9712 23.8567 42.8176 23.74 45.6612C23.5791 49.4424 23.4183 49.0681 24.0577 53.3347C24.6971 57.6013 24.6931 62.6198 28.5097 66.8864L29.2457 67.7809C29.2457 67.7809 33.5247 71.9714 34.7955 74.1031",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8691 40.351C24.8691 40.351 28.5168 38.8632 30.3426 38.9901",
    stroke: "#263238",
    strokeWidth: 0.546767,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand2);
export default __webpack_public_path__ + "static/media/hand-2.4f1d15969a733b9aabb5eb79f76ff869.svg";
export { ForwardRef as ReactComponent };